__turbopack_context__.v({
  "className": "inter_a1c499b1-module__Igsv9q__className",
});
